import React from "react";
import { motion } from "framer-motion";
import { DownloadIcon, InfinityIcon, ShieldCheckIcon, CreditCardIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { images } from "../../data/content";
const trust = [{
  icon: DownloadIcon,
  label: "Instant Download"
}, {
  icon: CreditCardIcon,
  label: "One-Time $27"
}, {
  icon: InfinityIcon,
  label: "Lifetime Access"
}, {
  icon: ShieldCheckIcon,
  label: "7-Day Guarantee"
}];
export function Hero() {
  return <header className="relative overflow-hidden bg-ink-950" data-id="element-177" data-mp="qvdqyoczt8vq">
      <div className="bg-alert px-4 py-2.5 text-center font-display text-xs font-extrabold uppercase tracking-wider text-white sm:text-sm" data-id="element-178" data-mp="qtj77ddgjmt8">
        Special launch offer · All 6 volumes + 5 bonuses for $27
      </div>
      <div className="mx-auto max-w-6xl px-5 pb-14 pt-10 sm:pt-14 lg:grid lg:grid-cols-[1.05fr_1fr] lg:items-center lg:gap-12 lg:pb-20" data-id="element-179" data-mp="10n9wgkhes19z">
        <div className="text-center lg:text-left" data-id="element-180" data-mp="1aitjsihwprn4">
          <p className="font-display text-sm font-extrabold uppercase tracking-[0.18em] text-brand" data-id="element-181" data-mp="1ah8sd1qw2oth">
            Occlusion Blueprint™ · The Clinical Occlusion System
          </p>
          <h1 className="mt-4 font-display text-[34px] font-black leading-[1.08] text-white sm:text-5xl lg:text-[56px]" data-id="element-182" data-mp="4nep686sovfn">
            Organize Your Occlusal Analysis in <span className="text-brand" data-id="element-183" data-mp="3ru7cbsieildn">15 Minutes</span> or Less
          </h1>
          <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-slate-300 sm:text-lg lg:mx-0" data-id="element-184" data-mp="se0ys3wg6nrr">
            A step-by-step clinical reference system to structure your occlusal assessment, organize your findings, and approach complex restorative cases with greater clarity.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="-mx-5 mt-6 sm:mx-auto sm:max-w-xl lg:row-span-2 lg:mt-0 lg:max-w-none" data-id="element-185" data-mp="enff4cz669st">
          <img src={images.main} alt="Occlusion Blueprint six-volume collection with digital resources" className="w-full drop-shadow-[0_30px_40px_rgba(46,196,201,0.18)]" data-id="element-186" data-mp="30lxiana1wz31" />
        </motion.div>

        <div className="mt-4 text-center lg:mt-8 lg:text-left" data-id="element-187" data-mp="2qw4218yyrvsg">
          <p className="mb-5 font-display text-lg font-extrabold text-white sm:text-xl" data-id="element-188" data-mp="2qvuc1ldx5omr">
            6 Professional Volumes <span className="text-brand" data-id="element-189" data-mp="2vt48hkzq70k3">+</span> 5 Exclusive Bonuses
          </p>
          <CtaButton id="first-cta" label="Get Occlusion Blueprint Now" data-id="element-190" data-mp="2htuwkxijyslx" />
          <ul className="mx-auto mt-5 grid max-w-xl grid-cols-2 gap-2.5 lg:mx-0" data-id="element-191" data-mp="2mvk6g9u1h08f">
            {trust.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center justify-center gap-2 rounded-xl bg-white/5 px-3 py-2.5 text-xs font-semibold text-slate-200 ring-1 ring-white/10 sm:text-sm lg:justify-start" data-id="element-192" data-mp="27zco7f26y8vs">
                <Icon className="h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-193" data-mp="63shl1uxk4k6" />
                {label}
              </li>)}
          </ul>
          <p className="mt-6 text-sm text-slate-400" data-id="element-194" data-mp="1vm8uqha63t74">
            Created for dentists who want a practical framework for evaluating occlusion — without constantly searching through scattered notes, textbooks, and clinical references.
          </p>
        </div>
      </div>

      <div className="border-y border-brand/30 bg-ink-800 px-5 py-8 text-center" data-id="element-195" data-mp="20mdgomtuhg4q">
        <p className="font-display text-xs font-extrabold uppercase tracking-[0.18em] text-brand" data-id="element-196" data-mp="20kaez5jbxyk6">Special Launch Offer</p>
        <p className="mx-auto mt-2 max-w-2xl font-display text-xl font-extrabold text-white sm:text-2xl" data-id="element-197" data-mp="2acg6ke5o6dyu">
          Get immediate access to all six volumes and five bonuses for just <span className="text-cta" data-id="element-198" data-mp="2o9bs3633xxvs">$27 USD</span>
        </p>
        <p className="mt-2 text-sm text-slate-300" data-id="element-199" data-mp="2jdwgylwhig32">Currency conversion is applied automatically according to your country.</p>
      </div>
    </header>;
}